import BaseModel from './BaseModel'

export default class MailBlocTextModel extends BaseModel {
  constructor(data: any, relation: any) {
    const fields = {
      LIBELLE: '',
      TEXTE: '',
      DEFAUT_PROPOSITION: 0,
      CONTEXTE_PROPOSITION: 0,
      DEFAUT_AUTRE: 0,
      CONTEXTE_AUTRE: 0,
      DEFAUT_BULK: 0,
      CONTEXTE_BULK: 0
    }
    super(data, relation, fields)
  }
}
